import { useState } from "react";

export default function SubscribeBar() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const handleClick = () => {
    if (!email.trim()) return;
    setDone(true);
    window.setTimeout(() => {
      setDone(false);
      setEmail("");
    }, 2600);
  };

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-100/70">
          <div className="grid grid-cols-1 items-center gap-8 p-6 md:p-10 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/80 px-3 py-1 text-xs font-bold text-primary-800">
                <i className="ri-notification-3-line text-sm"></i>
                爆料提醒
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                有新瓜第一时间通知你
              </h2>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-700">
                订阅关注的话题后，新线索、新声明与新讨论出现时会收到站内提醒，不用自己反复刷新页面。
              </p>
              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-primary-600"></i> 只推关注话题
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-primary-600"></i> 随时可退订
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-check-line text-primary-600"></i> 聚合每日摘要
                </span>
              </div>
            </div>

            <div className="rounded-lg bg-background-50 p-5 md:p-6">
              <label className="text-sm font-semibold text-foreground-800">提醒接收邮箱</label>
              <div className="mt-3 flex flex-col gap-2.5 sm:flex-row">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  className="h-11 flex-1 rounded-md border border-background-300 bg-background-100 px-4 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
                />
                <button
                  type="button"
                  onClick={handleClick}
                  className="flex h-11 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
                >
                  <i className="ri-notification-2-fill text-base"></i>
                  开启提醒
                </button>
              </div>
              {done ? (
                <p className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-primary-700">
                  <i className="ri-checkbox-circle-fill text-base"></i>
                  演示提示：本页为静态展示，邮箱不会被真实提交。
                </p>
              ) : (
                <p className="mt-3 text-xs text-foreground-500">
                  我们不会向他人分享你的邮箱，仅用于本页演示用途。
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}